// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3W4Dw","right":"Footer_right__3rz3J","buttons":"Footer_buttons__2bS7j"};